<template>
  <div class="i18n-test">
    <h1>{{ $t('common.welcome') }}</h1>
    
    <div class="current-locale">
      <p><strong>当前语言:</strong> {{ currentLocaleDisplay }}</p>
    </div>
    
    <el-divider>{{ $t('common.home') }}</el-divider>
    
    <div class="test-section">
      <h3>{{ $t('button.add') }} / {{ $t('button.remove') }}</h3>
      
      <el-form :label-position="'top'" label-width="100px">
        <el-form-item :label="$t('common.login')">
          <el-input v-model="testInput"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary">{{ $t('button.confirm') }}</el-button>
          <el-button>{{ $t('button.cancel') }}</el-button>
        </el-form-item>
      </el-form>
      
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" :label="$t('common.home')" width="180"></el-table-column>
        <el-table-column prop="name" :label="$t('button.add')" width="180"></el-table-column>
        <el-table-column prop="action" :label="$t('button.search')">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">{{ $t('button.view') }}</el-button>
            <el-button size="mini" type="danger">{{ $t('button.remove') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <el-divider>ElementUI 日期选择器测试</el-divider>
    
    <div class="test-section">
      <el-date-picker
        v-model="date"
        type="date"
        :placeholder="$t('common.home')">
      </el-date-picker>
    </div>
    
    <el-divider>{{ $t('common.contact') }}</el-divider>
    
    <div class="test-section">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="100">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'I18nTest',
  data() {
    return {
      testInput: '',
      date: '',
      currentPage: 1,
      tableData: [
        { id: 1, name: 'Test 1', action: '' },
        { id: 2, name: 'Test 2', action: '' },
        { id: 3, name: 'Test 3', action: '' }
      ]
    }
  },
  computed: {
    currentLocaleDisplay() {
      const locales = {
        'zh-CN': '简体中文',
        'zh-TW': '繁體中文',
        'en-US': 'English'
      };
      return locales[this.$i18n.locale] || this.$i18n.locale;
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
}
</script>

<style scoped>
.i18n-test {
  max-width: 800px;
  margin: 30px auto;
  padding: 20px;
}
.test-section {
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #eaeaea;
  border-radius: 4px;
}
h1 {
  text-align: center;
  margin-bottom: 30px;
}
.current-locale {
  text-align: center;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f0f9eb;
  border-radius: 4px;
}
</style> 


// WEBPACK FOOTER //
// src/components/I18nTest.vue